
export class Account {
    id: string;
    name: string;
    createdDate: Date;

    static fromJson(dict: any): Account {
        let acct = new Account();
        return acct.fromJson(dict);
    }

    //get the name and id from a base Alert
    fromJson(dict: any): Account {
        this.id = dict.id;
        this.name = dict.name;
        this.createdDate = dict.createdDate;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/account.ts